import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ActiveFaces, CubeService } from '../../services/cube.service';
import { Observable } from 'rxjs';
import { ThemeService } from '../../services/theme.service';
import { ScrollStateService } from '../../services/scroll-state.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-dock',
  imports: [CommonModule, TranslateModule],
  templateUrl: './dock.component.html',
  styleUrls: ['./dock.component.css']
})
export class DockComponent implements OnInit, AfterViewInit {

  @Output() sectionChange = new EventEmitter<number>();

  @ViewChild('dock', { read: ElementRef }) dockEl?: ElementRef<HTMLElement>;


  navItems = [
    { route: 'home', icon: 'bx bx-home-alt', tooltipKey: 'DOCK.HOME' },
    { route: 'about-us', icon: 'bx bx-user', tooltipKey: 'DOCK.ABOUT' },
    { route: 'resume', icon: 'bx bx-detail', tooltipKey: 'DOCK.RESUME' },
    { route: 'portfolio', icon: 'bx bx-briefcase', tooltipKey: 'DOCK.PORTFOLIO' },
    { route: 'blog', icon: 'bx bx-book-heart', tooltipKey: 'DOCK.BLOG' },
    { route: 'contact', icon: 'bx bx-envelope', tooltipKey: 'DOCK.CONTACT' }
  ];
  isAnimating = false;
  isLocked = false;

  activeIndex = 0;
  activeFaces$: Observable<ActiveFaces>;
  isDarkMode: any;

  constructor(
    private cubeService: CubeService
    , private themeService: ThemeService
    , public scroll: ScrollStateService) {
    this.activeFaces$ = cubeService.activeFaces$;
  }

  ngOnInit(): void {

    // this.updateDockHeight();
    // Abonniere den CurrentIndex aus CubeService und leite daraus den aktiven Index ab.
    this.cubeService.currentIndex$.subscribe(index => {
      this.activeIndex = index;
      this.sectionChange.emit(index);
    });

    this.themeService.isDarkMode$.subscribe(mode => {
      this.isDarkMode = mode;
      Promise.resolve().then(() => {
        const triggeredByToggle = this.themeService.wasThemeToggled();
        this.updateDock(triggeredByToggle);
      });
    });

    this.cubeService.isLocked$.subscribe(lock => {
      setTimeout(() => {
        this.isLocked = lock;
      });
    });

    if (window.matchMedia("(hover: none) and (pointer: coarse)").matches) {
      document.querySelectorAll('.tooltip').forEach(tip => {
        const parent = tip.parentElement;

        // Tooltip anzeigen, wenn Eltern-Element getappt wird
        parent.addEventListener('click', () => {
          tip.classList.add('show');
          setTimeout(() => tip.classList.remove('show'), 2000); // 2 Sekunden sichtbar
        });
      });
    }



  }

    ngAfterViewInit(): void {
    // this.registerAll(this.dockRef.nativeElement);
      // Initiale Messung
  // this.updateDockHeight();
  // Reaktiv bei Größenänderung
  // this.footerResizeObserver = new ResizeObserver(() => {
  //   this.updateFooterHeight();
  // });
}

  getDockElement(): HTMLElement | null {
    return this.dockEl?.nativeElement ?? null;
  }

  navigateTo(route: string, index: number) {
    if (this.isAnimating || this.activeIndex === index || this.isLocked) {
      return; // <--- Blockieren, wenn Animation läuft oder gleiche Seite gewählt
    }

    this.isAnimating = true;  // <--- Animation beginnt

    this.activeIndex = index;
    this.cubeService.setActiveFace(index);

    this.scroll.resetVisibility();

    // Angenommene Animationsdauer: 2000ms (je nachdem, wie lange dein Cube dreht)
    setTimeout(() => {
      this.isAnimating = false;  // <--- Nach Animation wieder freigeben
    }, 2000);
  }


  private updateDock(triggeredByToggle: boolean): void {

    if (!this.dockEl) {
      return
    }

    const dock = this.dockEl.nativeElement;

    setTimeout(() => {
      if (this.isDarkMode) {
        dock.classList.add('dark-mode');
      } else {
        dock.classList.remove('dark-mode');
      }
    }, 700)

  }

  // private updateDockHeight(): void {
  //   if (!this.dockRef) return;

  //   const h = Math.round(
  //     this.dockRef.nativeElement.offsetHeight
  //   );

  //   document.documentElement
  //     .style
  //     .setProperty('--dock-h', `${h}px`);

  //   console.log('[DockHeight]', h);
  // }
}
